// Typelizer digest 3c7c0ca52ef084e29f4d3fa857d6e08d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/classes/:class_id/go_live */
  show: (
    params: { teacherId: string | number; classId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/classes/:class_id/go_live', params, options),
    method: 'get',
  }),

  /** POST /educators/teachers/:teacher_id/classes/:class_id/go_live */
  create: (
    params: { teacherId: string | number; classId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/classes/:class_id/go_live', params, options),
    method: 'post',
  }),
}
